module.exports = __webpack_public_path__ + "img/xiangqi8xiaozhen.08e2541b.png";